const wrapperPaddingDefault = 16;
const wrapperPaddingCompact = 8;

const dividerSize = 2;

const wrapperGapDefault = wrapperPaddingDefault + dividerSize;
const wrapperGapCompact = wrapperPaddingCompact + dividerSize;

export const tokens = {
    wrapper: {
        gap: {
            default: wrapperGapDefault,
            compact: wrapperGapCompact,
        },
        padding: {
            default: wrapperPaddingDefault,
            compact: wrapperPaddingCompact,
        },
    },
    divider: {
        offset: {
            default: wrapperGapDefault / 2 - dividerSize / 2,
            compact: wrapperGapCompact / 2 - dividerSize / 2,
        },
    },
    focusRing: {
        offset: 4,
    },
    height: {
        default: 40,
        compact: 24,
    },
    fontSize: {
        default: 14,
        compact: 10,
    },
    radius: {
        default: 10,
        compact: 6,
    },
    price: {
        gap: 4,
    },
};
